import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    WorksheetEntitySummaryIndex,
    WorksheetPageIndex
} from 'services/worksheet/types';
import { makeSelectBlocks } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

type Props = OwnProps;

export default function BlocksTableCell(props: Props): React.ReactElement {
    const blocks = useSelector((state: AppState) =>
        makeSelectBlocks()(state, props)
    );

    return <TableCell>{blocks}</TableCell>;
}
